import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Factory, MapPin, PackageCheck, ArrowLeft } from 'lucide-react';
import { network } from '../lib/api';
import ReputationPanel from '../components/ReputationPanel';

export default function FactoryProfile() {
  const { ms_id } = useParams();
  const [entity, setEntity] = useState(null);
  const [catalog, setCatalog] = useState([]);
  const [err, setErr] = useState('');

  useEffect(() => {
    if (!ms_id) return;
    network.lookup(ms_id)
      .then(setEntity)
      .catch(e => setErr(e?.response?.data?.detail || 'Factory not found'));
    network.factoryCatalog(ms_id)
      .then(r => setCatalog(r.products || []))
      .catch(() => setCatalog([]));
  }, [ms_id]);

  if (err) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-16 text-center">
        <div className="text-sm text-ink/60">{err}</div>
        <Link to="/supply-chain" className="btn-primary mt-6 inline-flex"><ArrowLeft className="w-4 h-4"/>Back to Supply Chain</Link>
      </div>
    );
  }
  if (!entity) return <div className="max-w-3xl mx-auto px-6 py-16 text-ink/60">Loading…</div>;

  return (
    <div className="max-w-5xl mx-auto px-4 md:px-6 py-10">
      <div className="flex items-start gap-4 flex-wrap">
        <div className="w-16 h-16 rounded-2xl bg-[#FFF8EE] grid place-items-center text-[#D35400]">
          <Factory className="w-8 h-8"/>
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-[#D35400]">Factory / Brand-owner</div>
          <h1 data-testid="factory-name" className="font-heading font-black text-3xl md:text-4xl mt-1">
            {entity.business_name}
          </h1>
          <div className="text-sm text-ink/60 mt-1 inline-flex flex-wrap gap-4">
            <span className="font-mono">{entity.ms_id}</span>
            <span className="inline-flex items-center gap-1"><MapPin className="w-4 h-4"/>Pincode {entity.pincode}</span>
          </div>
        </div>
      </div>

      <section className="card-soft p-5 mt-6">
        <div className="font-heading font-bold text-lg flex items-center gap-2">
          <PackageCheck className="w-5 h-5"/> Catalog · {catalog.length} SKUs
        </div>
        {catalog.length === 0
          ? <div className="mt-3 text-sm text-ink/60">This factory has not listed any SKUs yet.</div>
          : (
            <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-2">
              {catalog.map(p => (
                <div key={p.id} data-testid={`factory-sku-${p.id}`}
                  className="rounded-lg border border-border bg-white p-3">
                  <div className="font-semibold text-sm truncate">{p.name}</div>
                  <div className="text-xs text-ink/60">
                    ₹{Number(p.price).toLocaleString('en-IN')} / {p.unit || 'pc'} · MOQ {p.moq}
                  </div>
                </div>
              ))}
            </div>
          )
        }
      </section>

      {/* 360° Reputation panel — only verified buyer distributors/dealers can post */}
      <ReputationPanel kind="factory" targetId={entity.ms_id} title="Trust rating from partners"/>
    </div>
  );
}
